import React from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import ClientManagement from '../pages/ClientManagement';
import ClientDetails from '../pages/ClientDetails';
import FinancialAnalysis from '../pages/FinancialAnalysis';
import ClientFinancialReport from '../pages/ClientFinancialReport';
import ProposalManagement from '../pages/ProposalManagement';
import UserManagement from '../pages/UserManagement';
import ClientPortal from '../pages/ClientPortal';
import ClientFinancialAnalysis from '../pages/ClientFinancialAnalysis';
import ProfileSettings from '../pages/ProfileSettings';
import ProjectionsSettings from '../pages/ProjectionsSettings';

// Define role constants
export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  ADVISOR: 'advisor',
  EMD: 'emd',
  SMD: 'smd',
  MARKETING_DIRECTOR: 'marketing_director',
  SENIOR_ASSOCIATE: 'senior_associate',
  ASSOCIATE: 'associate',
  REPRESENTATIVE: 'representative',
  ASSISTANT: 'assistant',
  EXECUTIVE_ASSISTANT: 'executive_assistant',
  CLIENT: 'client'
};

export const PROFESSIONAL_ROLES = Object.values(ROLES).filter(
  role => role !== ROLES.CLIENT
);

// Define routes with their access controls
export const routes = [
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
    requireAuth: true
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
    requireAuth: true
  },
  {
    path: '/client-portal',
    element: <ClientPortal />,
    requireAuth: true,
    allowedRoles: [ROLES.CLIENT]
  },
  {
    path: '/client-financial-analysis',
    element: <ClientFinancialAnalysis />,
    requireAuth: true,
    allowedRoles: [ROLES.CLIENT]
  },
  {
    path: '/clients',
    element: <ClientManagement />,
    requireAuth: true,
    allowedRoles: PROFESSIONAL_ROLES
  },
  {
    path: '/clients/:clientId',
    element: <ClientDetails />,
    requireAuth: true,
    allowedRoles: PROFESSIONAL_ROLES
  },
  {
    path: '/financial-analysis',
    element: <FinancialAnalysis />,
    requireAuth: true,
    allowedRoles: PROFESSIONAL_ROLES
  },
  {
    path: '/financial-analysis/:clientId',
    element: <FinancialAnalysis />,
    requireAuth: true,
    allowedRoles: PROFESSIONAL_ROLES
  },
  {
    path: '/clients/:clientId/report',
    element: <ClientFinancialReport />,
    requireAuth: true
  },
  {
    path: '/proposals',
    element: <ProposalManagement />,
    requireAuth: true,
    allowedRoles: PROFESSIONAL_ROLES
  },
  {
    path: '/users',
    element: <UserManagement />,
    requireAuth: true,
    allowedRoles: [ROLES.ADMIN, ROLES.MANAGER]
  },
  {
    path: '/projections-settings',
    element: <ProjectionsSettings />,
    requireAuth: true,
    allowedRoles: [ROLES.ADMIN]
  },
  {
    path: '/profile-settings',
    element: <ProfileSettings />,
    requireAuth: true
  }
];